import { createSlice } from "@reduxjs/toolkit";
import { cleanObject } from "../../helpers";

const initialState = {
  order_price_mod: {
    discount: null,
    delivery_fee: null,
    giftcard: null,
    loyalty_point: null,
  },

  payment: {},
  customer: null,
  store_wallet: null,
  table: null,
  order_type: null,
  order_note: null,
  ledger_account_id: null,
};

export const checkoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    addDiscount: (state, action) => {
      state.order_price_mod.discount = action.payload
        ? { ...action.payload, type: "flat" }
        : null;
    },
    addDelivery: (state, action) => {
      state.order_price_mod.delivery_fee = action.payload
        ? { ...action.payload, type: "flat" }
        : null;
    },
    addLoyaltyPoint: (state, action) => {
      state.order_price_mod.loyalty_point = action.payload
        ? { ...action.payload }
        : null;
    },
    addGiftcard: (state, action) => {
      state.order_price_mod.giftcard = action.payload
        ? { ...action.payload }
        : null;
    },
    resetOrderPriceMod: (state) => {
      state.order_price_mod = {
        discount: null,
        delivery_fee: null,
        giftcard: null,
        loyalty_point: null,
      };
    },
    addCustomer: (state, action) => {
      state.customer = action.payload;
    },
    addTable: (state, action) => {
      state.table = action.payload;
    },
    addNote: (state, action) => {
      state.order_note = action.payload;
    },
    addOrderType: (state, action) => {
      state.order_type = action.payload;
    },
    addPayment: (state, action) => {
      state.payment = action.payload;
    },
    addStoreWallet: (state, action) => {
      state.store_wallet = action.payload;
    },
    addLedgerAccoount: (state, action) => {
      state.ledger_account_id = action.payload;
    },
    updateCurrentPaymentInfo: (state, action) => {
      const key = action.payload.key;
      const data = cleanObject({
        ...state.payment[key],
        ...action.payload,
        key: null,
      });
      state.payment[key] = data;
    },
    resetCheckoutInfo: (state) => {
      state.order_price_mod = initialState?.order_price_mod;
      state.payment = initialState.payment;
      state.customer = initialState.customer;
      state.table = initialState.table;
      state.order_type = initialState.order_type;
      state.order_note = initialState.order_note;
      state.store_wallet = initialState.store_wallet;
      state.ledger_account_id = initialState.ledger_account_id;
    },
  },
});

export const {
  addDiscount,
  addDelivery,
  addLoyaltyPoint,
  addGiftcard,
  addCustomer,
  addTable,
  addNote,
  addOrderType,
  resetOrderPriceMod,
  addPayment,
  addLedgerAccoount,
  updateCurrentPaymentInfo,
  addStoreWallet,
  resetCheckoutInfo,
} = checkoutSlice.actions;
